import React from "react";

export default function HungKingsFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-hun62{fill:#900}.cls-hun63{fill:#dd6c6c}.cls-hun64{fill:#ff5b00}"
            }
          </style>
        </defs>
        <path
          d="M1475.28 1957.15H524.71c-52.2 0-94.67-42.47-94.67-94.67V911.91c0-52.2 42.47-94.67 94.67-94.67h950.57c52.2 0 94.67 42.47 94.67 94.67v950.57c0 52.2-42.47 94.67-94.67 94.67ZM524.72 854.95c-31.41 0-56.97 25.56-56.97 56.97v950.57c0 31.41 25.56 56.97 56.97 56.97h950.57c31.41 0 56.97-25.56 56.97-56.97V911.92c0-31.41-25.56-56.97-56.97-56.97H524.72Z"
          className="cls-hun64"
        />
        <path
          d="M868.59 837.06c50.68-7.66 101.37-15.32 152.05-22.97-34.21-180.85-68.42-361.71-102.62-542.56-59.6 36.48-119.2 72.97-178.8 109.45 43.12 152.03 86.25 304.06 129.37 456.08Z"
          className="cls-hun62"
        />
        <path
          d="M836.08 862.99c22.86-6.87 45.71-13.73 68.57-20.6l-121.77-403.9c-53.15 24.13-106.29 48.25-159.44 72.38 70.88 117.37 141.76 234.75 212.63 352.12Z"
          className="cls-hun64"
        />
        <rect
          width={451.83}
          height={13}
          x={647.57}
          y={564.94}
          className="cls-hun63"
          rx={6.5}
          ry={6.5}
          transform="rotate(77.63 873.468 571.385)"
        />
        <circle cx={728.99} cy={549.58} r={42.51} className="cls-hun62" />
        <circle cx={728.99} cy={549.58} r={22.44} className="cls-hun64" />
        <circle cx={809.37} cy={715.89} r={42.51} className="cls-hun62" />
        <circle cx={809.37} cy={715.89} r={22.44} className="cls-hun64" />
        <circle cx={768.55} cy={632.74} r={21.25} className="cls-hun62" />
        <circle cx={768.55} cy={632.74} r={11.22} className="cls-hun64" />
        <path
          d="M1131.41 836.1c-50.68-7.66-101.37-15.32-152.05-22.97 34.21-180.85 68.42-361.71 102.62-542.56 59.6 36.48 119.2 72.97 178.8 109.45-43.12 152.03-86.25 304.06-129.37 456.08Z"
          className="cls-hun62"
        />
        <path
          d="M1163.92 862.03c-22.86-6.87-45.71-13.73-68.57-20.6l121.77-403.9c53.15 24.13 106.29 48.25 159.44 72.38-70.88 117.37-141.76 234.75-212.63 352.12Z"
          className="cls-hun64"
        />
        <path
          d="M1216.87 915.06H783.08c-9.99 0-17.46-9.83-15.44-20.32l13.91-72.26c1.51-7.85 7.96-13.49 15.44-13.49h404.89c7.39 0 13.79 5.5 15.39 13.23 4.99 24.09 9.99 48.18 14.98 72.26 2.19 10.55-5.31 20.57-15.39 20.57Z"
          className="cls-hun64"
        />
        <path
          d="M1120.07 210.7c-.91 7.29-1.83 14.57-2.74 21.86l-72.93 580.58h-90.32c-26.51-193.3-53.03-386.61-79.55-579.9-1.15-8.38-2.29-16.76-3.45-25.15 36.56-43 73.13-85.99 109.7-128.98 4.93-5.8 9.87-11.6 14.8-17.41 5.1 6.1 10.2 12.21 15.3 18.3 36.4 43.57 72.8 87.13 109.2 130.7Z"
          className="cls-hun64"
        />
        <path
          d="M1216.88 915.07h-3.02c-4.15-21.59-8.3-43.19-12.45-64.77-1.49-7.73-7.42-13.24-14.27-13.24h-375.3c-6.94 0-12.91 5.63-14.32 13.48l-11.51 64.52h-2.92c-9.99 0-17.46-9.83-15.44-20.32l13.91-72.26c1.51-7.85 7.96-13.49 15.45-13.49h404.89c7.38 0 13.79 5.51 15.39 13.24 4.99 24.09 9.99 48.18 14.98 72.26 2.19 10.56-5.3 20.57-15.39 20.57Z"
          style={{
            fill: "#ed4f00",
          }}
        />
        <rect
          width={451.83}
          height={13}
          x={900.6}
          y={563.98}
          className="cls-hun63"
          rx={6.5}
          ry={6.5}
          transform="rotate(102.37 1126.521 570.536)"
        />
        <rect
          width={394.71}
          height={10.91}
          x={802.62}
          y={501.96}
          rx={5.45}
          ry={5.45}
          style={{
            fill: "#fc864c",
          }}
          transform="rotate(90 999.98 507.41)"
        />
        <circle cx={1271.01} cy={548.63} r={42.51} className="cls-hun62" />
        <circle cx={1271.01} cy={548.63} r={22.44} className="cls-hun64" />
        <circle cx={995.57} cy={225.41} r={69.44} className="cls-hun62" />
        <circle cx={995.57} cy={225.41} r={36.66} className="cls-hun64" />
        <circle cx={1190.63} cy={714.93} r={42.51} className="cls-hun62" />
        <circle cx={1190.63} cy={714.93} r={22.44} className="cls-hun64" />
        <circle cx={1231.45} cy={631.78} r={21.25} className="cls-hun62" />
        <circle cx={999.98} cy={749.66} r={21.25} className="cls-hun62" />
        <circle cx={1231.45} cy={631.78} r={11.22} className="cls-hun64" />
        <circle cx={999.98} cy={749.66} r={11.22} className="cls-hun64" />
        <path
          d="m1010.87 80-14.65 16.46-121.71 136.77c-1.15-8.38-2.29-16.76-3.45-25.15 36.56-43 73.13-85.99 109.7-128.98 4.93-5.8 9.87-11.6 14.8-17.41 5.1 6.1 10.2 12.21 15.3 18.3Z"
          className="cls-hun62"
        />
        <path
          d="M1120.07 210.7c-.91 7.29-1.83 14.57-2.74 21.86l-121.1-136.1-15.45-17.36c4.93-5.8 9.87-11.6 14.8-17.41 5.1 6.1 10.2 12.21 15.3 18.3 36.4 43.57 72.8 87.13 109.2 130.7Z"
          className="cls-hun62"
        />
        {children}
      </g>
    </svg>
  );
}
